
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator} from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  NgZone,
  ElementRef,
  VERSION,
  Inject,
  Input,
  ChangeDetectorRef
} from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Subject } from "rxjs";
import { HttpClientModule } from "@angular/common/http";
import { DataTableDirective } from "angular-datatables";
import { DOCUMENT } from '@angular/common';
import { logbaseService } from "../../services/logbase.service";
import { dataService } from "../../services/data.service";
import { DatePipe } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { dateFormatPipe } from "../../pipes/dateFormatPipe";
import { event } from 'jquery';

export interface PartsData{
  partNumber:any;
  partName:any;
  deliverPoint:any;
  lineNumber:any;
  assignedDate:any;
  dueDate:any;
}

/**
 * @title Table retrieving data through HTTP
 */
@Component({
  selector: "app-new-parts",
  templateUrl: "./new-parts.component.html",
  styleUrls: ["./new-parts.component.scss"]
})
export class NewPartsComponent implements OnInit, AfterViewInit {

 
  dataSource: MatTableDataSource<PartsData[]>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns = ['partNumber', 'partName', 'deliveryPoint', 'nextProcess','assignedDate','dueDate'];
  newPartsData: any[] = [];
  parts: any;
  // ng2-table code
  public rows: Array<any> = [];

  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;
  private data: Array<any> = [];
  srchValue:any;

  column_n:any={}
  data_n=[]

  



  // ng2-table code ends


  constructor(private http: HttpClient, @Inject(DOCUMENT) private document: any, private logbaseService: logbaseService,
    private dataService: dataService, private spinner: NgxSpinnerService, private translate: TranslateService,
    private httpClient: HttpClient, private ref: ChangeDetectorRef) {
      this.columns= [
        { title: this.translate.instant('PARTNO'), name: 'partNumber' },
        { title: this.translate.instant('PARTNAME'), name: 'partName' },
        { title: this.translate.instant('DELIVERYPOINT'), name: 'deliveryPoint' },
        { title: this.translate.instant('LINENUMBER'), name: 'lineNumber' },
        { title: this.translate.instant('ASSIGNEDDATE'), name: 'assignedDate' },
        { title: this.translate.instant('DUEDATE'), name: 'dueDate' }
      ];
     this.config = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        className: ['table-striped', 'table-bordered']
      };

  }
  public columns:any;
  public config: any


  ngOnInit() {

    //this.data = this.appService.getData();
    this.column_n = [
        { key: 'partNumber', title: "Part Number" },
        { key: 'partName', title: 'Part Name' },
        { key: 'deliveryPoint', title: 'Delivery Point' },
        { key: 'lineNumber', title: 'Next Process'},
        { key: 'assignedDate', title: 'Assigned Date' },
        { key: 'dueDate', title: 'Due Date' },
    ]
    this.onChangeTable(this.config, true);

    this.spinner.show();
  }

  tablechange(event:any)
  {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let userRoleId = userDetJson.userRoleMappings[0].roleId;
    let userSuppCode = userDetJson.supplierCode;

    var dataToSend = {
      pageNum: event.pageIndex,
      partStatus: "new",
      roleId: userRoleId,
      //searchValue: this.config.filtering.filterString,
      size: event.pageSize,
      // sortColumn: sortData.name,
      // sortType: sortData.sort,
      supplierCodes: userSuppCode
    };

    this.logbaseService.getNewPartsPage(dataToSend).subscribe(result => {
      
      this.parts = result;
      var partArr;
      var partsData = [];
      

      this.parts.response.content.forEach(function (value, key) {
        var dateFormatPipeFilter = new dateFormatPipe();
        // if (value.isActive == false) {
        //   partArr = {
        //     partNumber: value.partNumber,
        //     partName: value.partName,
        //     // packageId: value.packageId,
        //     deliveryPoint: value.deliveryPoint,
        //     lineNumber: value.lineNumber,
        //     assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
        //     dueDate: dateFormatPipeFilter.transform(value.dueDate)
        //   };
        // } else {
          partArr = {
            partNumber: value.packageId,
              // '<a class="partno_column" href="#/partDetails/partsInfo/' +
              // value.packageId +
              // '">' +
              // value.partNumber +
              // "</a>",
             

              
            partName: value.partName,
            // packageId: value.packageId,
            deliveryPoint: value.deliveryPoint,
            lineNumber: value.lineNumber,
            assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
            dueDate: dateFormatPipeFilter.transform(value.dueDate)
          };
        //}
        partsData.push(partArr);
      });

      this.newPartsData = partsData;
      this.dataSource=new MatTableDataSource<PartsData[]>(this.newPartsData);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      // this.dataSource.data=this.newPartsData;
      this.data_n=this.newPartsData
     

      this.data = partsData;
      this.length = this.parts.response.totalElements;
    });


  }
  

  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
    console.log("paginator",this.paginator)
    



  }

  myClick(event:any)
  {
    console.log("hi",event)
}

 

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

 

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? start + page.itemsPerPage : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== "" && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === "desc" ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === "asc" ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(
          this.config.filtering.filterString
        )
      );
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (
          item[column.name] !== null &&
          item[column.name].toString().match(this.config.filtering.filterString)
        ) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    console.log("in on change")
    var pageNo;
    var sortData;
    var dateFormatPipeFilter = new dateFormatPipe();

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort != "") {
        sortData = {
          name: value.name,
          sort: value.sort
        };
      }
    });

    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let userRoleId = userDetJson.userRoleMappings[0].roleId;
    let userSuppCode = userDetJson.supplierCode;

    var dataToSend = {
      pageNum: pageNo,
      partStatus: "new",
      roleId: userRoleId,
      searchValue: this.srchValue,
      size: this.itemsPerPage,
      // sortColumn: sortData.name,
      // sortType: sortData.sort,
      supplierCodes: userSuppCode
    };

    this.spinner.show();
    this.logbaseService.getNewPartsPage(dataToSend).subscribe(result => {
      
      this.parts = result;
      this.totalItems=this.parts.response.totalElements;
      var partArr;
      var partsData = [];
      

      this.parts.response.content.forEach(function (value, key) {
        // if (value.isActive == false) {
        //   partArr = {
        //     partNumber: value.partNumber,
        //     partName: value.partName,
        //     // packageId: value.packageId,
        //     deliveryPoint: value.deliveryPoint,
        //     lineNumber: value.lineNumber,
        //     assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
        //     dueDate: dateFormatPipeFilter.transform(value.dueDate)
        //   };
        // } else {
          partArr = {
            partNumber: value.partNumber,
            packageId: value.packageId ,

            partName: value.partName,
            // packageId: value.packageId,
            deliveryPoint: value.deliveryPoint,
            lineNumber: value.lineNumber,
            assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
            dueDate: dateFormatPipeFilter.transform(value.dueDate)
          };
        //}
        partsData.push(partArr);
      });

      this.newPartsData = partsData;
      this.dataSource=new MatTableDataSource<PartsData[]>(this.newPartsData);
      // this.dataSource.data=this.newPartsData;
      this.data_n=this.newPartsData
     

      this.data = partsData;
      this.length = this.parts.response.totalElements;
      this.columns = [
        { title: this.translate.instant('PARTNO'), name: 'partNumber' },
        { title: this.translate.instant('PARTNAME'), name: 'partName' },
        { title: this.translate.instant('DELIVERYPOINT'), name: 'deliveryPoint' },
        { title: this.translate.instant('LINENUMBER'), name: 'lineNumber' },
        { title: this.translate.instant('ASSIGNEDDATE'), name: 'assignedDate' },
        { title: this.translate.instant('DUEDATE'), name: 'dueDate' }
      ];
      // this.rerenderTable(this.config, true);
      // this.ref.detectChanges();
      // });
      let filteredData = this.changeFilter(this.data, this.config);
      let sortedData = this.changeSort(filteredData, this.config);
      this.rows =
        page && config.paging ? this.changePage(page, sortedData) : sortedData;
      //this.length = sortedData.length;

      this.rerenderTable(this.config, true);
      this.ref.detectChanges();
      this.spinner.hide();
    });

  }

  paginate(event:any)
  {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let userRoleId = userDetJson.userRoleMappings[0].roleId;
    let userSuppCode = userDetJson.supplierCode;
    var dateFormatPipeFilter = new dateFormatPipe();

    var dataToSend = {
      pageNum: event.page,
      partStatus: "new",
      roleId: userRoleId,
      searchValue: "",
      size: 10,
      // sortColumn: sortData.name,
      // sortType: sortData.sort,
      supplierCodes: userSuppCode
    };

    this.spinner.show();
    this.logbaseService.getNewPartsPage(dataToSend).subscribe(result => {
      
      this.parts = result;
      //this.totalItems=this.parts.response.totalElements;
      var partArr;
      var partsData = [];
      

      this.parts.response.content.forEach(function (value, key) {
        // if (value.isActive == false) {
        //   partArr = {
        //     partNumber: value.partNumber,
        //     partName: value.partName,
        //     // packageId: value.packageId,
        //     deliveryPoint: value.deliveryPoint,
        //     lineNumber: value.lineNumber,
        //     assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
        //     dueDate: dateFormatPipeFilter.transform(value.dueDate)
        //   };
        // } else {
          partArr = {
            partNumber: value.packageId,
              // '<a class="partno_column" href="#/partDetails/partsInfo/' +
              // value.packageId +
              // '">' +
              // value.partNumber +
              // "</a>",
             

              
            partName: value.partName,
            // packageId: value.packageId,
            deliveryPoint: value.deliveryPoint,
            lineNumber: value.lineNumber,
            assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
            dueDate: dateFormatPipeFilter.transform(value.dueDate)
          };
        //}
        partsData.push(partArr);
      });

      this.newPartsData = partsData;
      this.dataSource=new MatTableDataSource<PartsData[]>(this.newPartsData);
    })
  }

  public rerenderTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows =
      page && config.paging ? this.changePage(page, sortedData) : sortedData;
    //this.length = sortedData.length;
  }

  //public onCellClick(data: any): any { }
}
